import { createAsyncThunk } from '@reduxjs/toolkit';
import { VestingInfo } from '../../../models/VestingInfo';

import { ThunkAPIModel } from '../../../models/ThunkAPI.model';
import { fetchVestingInfo } from '../../../services/vestingApi';
export type VestingInfoRequest = {
  vestingContractAddresses: string[];
};
export type VestingInfoResponse = {
  vestingInfoList: VestingInfo[];
  bknAmount?: string;
  bnbAmount?: string;
};
export const getVestingInfo = createAsyncThunk<
  VestingInfoResponse,
  VestingInfoRequest,
  ThunkAPIModel
>('vestingInfo/getVestingInfo', async (request, thunkApi) => {
  try {
    const { vestingContractAddresses } = request;

    return fetchVestingInfo(vestingContractAddresses);
  } catch (error) {
    return thunkApi.rejectWithValue({
      errorMessage: error.message
    });
  }
});
